import React, { PropTypes } from 'react';
import Empty from './Empty';

class EmptyPage extends React.PureComponent {
  static propTypes = {
    view_info: PropTypes.func
  };

  componentDidMount() {
    // Sending view info to Restaurant.js to feed the Top and Bottom bars
    this.props.view_info(
      //title
      '',
      //view
      'list',
      //back button or not
      true
    );
  }

  render() {
    return (
      <div className="content-wrapper">
        <div className="item-list loaded">
          <Empty />
        </div>

      </div>
    );
  }
}


export default EmptyPage;



/** WEBPACK FOOTER **
 ** ./src/components/restaurant/core/EmptyPage.js
 **/